export default __webpack_public_path__ + "static/media/us-health-vest-atlanta-1.11481e68.jpg";